export type SendProductRequestFormData = {
  isAuthenticated: boolean
  fullName: string
  email: string
  phoneNumber: string
  description: string
  regionId: number | undefined
}

export const getFormInitialValues = (desription: string): SendProductRequestFormData => {
  return {
    isAuthenticated: false,
    email: '',
    phoneNumber: '',
    fullName: '',
    description: desription,
    regionId: undefined,
  }
}
